import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import KycVerifiedIcon from '../../../components/Icons/KycVerifiedIcon';

const BusinessBioArea = () => {
  const { jsonData } = useParams();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  return (
    <ContainerWrapper>
      <Container>
        <Img
          src={
            !!objectFyData?.profilePicture
              ? objectFyData.profilePicture
              : '/static/img/profilePlaceholder2.png'
          }
        />
        <TextArea>
          <FirstTextRow>
            <BoldText>
              {objectFyData?.firstName} {objectFyData?.lastName}
            </BoldText>
          </FirstTextRow>

          <BusinessInfoArea>
            <BoldTextRow>
              {objectFyData?.companyName ?? 'Cala Foods'}
            </BoldTextRow>

            <KycVerifiedBadge>
              <KycVerifiedIcon />
              KYC Verified
            </KycVerifiedBadge>
          </BusinessInfoArea>

          <TextRow>Partner</TextRow>

          <TextRow>
            <div>Active since:</div>
            <BoldNumberText>
              {objectFyData?.timeAtCompany || 'N/A'}
            </BoldNumberText>
          </TextRow>
        </TextArea>
      </Container>
    </ContainerWrapper>
  );
};

export default BusinessBioArea;

const ContainerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  flex-direction: column;
`;

const BusinessInfoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const KycVerifiedBadge = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #5c5963;
  background-color: rgba(91, 145, 245, 0.05);
  padding: 4px 11px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 183, 63, 0.1);
  color: #00b73f;
  gap: 4px;
`;

const BoldTextRow = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  gap: 16px;
  border-radius: 5px;

  gap: 24px;

  @media (max-width: 884px) {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;

  @media (max-width: 884px) {
    min-width: 91px;
    min-height: 91px;
  }
`;

const BoldText = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const FirstTextRow = styled.div`
  display: flex;
  gap: 12px;
`;

const TextRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  &.broken {
    @media (max-width: 884px) {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
    }
  }
`;

const BoldNumberText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;

  &.margin-left {
    margin-left: 10px;
  }
`;
